import React, {Component, PropTypes} from 'react'
import Url from '../Url'

class Footer extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;

    if (this.affiliate === 'kwtv') {
      this.state = {
        hideFooter: false,
        name: 'News 9',
        address: '7401 N Kelley Ave',
        city: 'Oklahoma City',
        state: 'OK',
        zip: '73111',
        phone: '405-843-6641',
        shortUrl: 'News9.com',
        mapUrl: 'https://ftpcontent.worldnow.com/griffin/NEXGEN_Images/kwtv_map.png',
        mapHref: 'https://www.google.com/maps/place/KWTV+News+9/@35.5481854,-97.4986936,17z/data=!3m1!4b1!4m5!3m4!1s0x87b219a733117a87:0x86cf9395c7f1cb3e!8m2!3d35.5481854!4d-97.4965049'
      }
    } else {
      this.state = {
        hideFooter: false,
        name: 'News On 6',
        address: '303 N Boston Ave',
        city: 'Tulsa',
        state: 'OK',
        zip: '74103',
        phone: '918-732-6000',
        shortUrl: 'Newson6.com',
        mapUrl: 'https://ftpcontent.worldnow.com/griffin/NEXGEN_Images/kotv_map.png',
        mapHref:'https://www.google.com/maps/place/News+On+6+KOTV/@36.160321,-95.9947127,17z/data=!3m1!4b1!4m5!3m4!1s0x87b6eb7fa4d01791:0xd95893ab6017140b!8m2!3d36.160321!4d-95.992524'
      }
    }

  }

  componentWillMount(){

    this.setState({
      hideFooter: Url.params(this.props.FRN_page).hideFooter === "true"
    })
  }



  render() { // REQUIRED
    if(this.state.hideFooter)
      return null
    return (
      <div className='gnm-footer'>
        <div className='container'>
          <div className='row'>

            <div className='col-sm-4 col-md-3 major-column'>
              <div className='row social-icon-row'>
                <div className='col-xs-2'  />
                <div className='col-xs-2'>
                  <a href={this.props.facebook} target="_blank" className='social-icons centered'>
                    <i className='fa fa-facebook'  />
                  </a>
                </div>
                <div className='col-xs-2'>
                  <a href={this.props.twitter} target="_blank" className='social-icons centered'>
                    <i className='fa fa-twitter'  />
                  </a>
                </div>
                <div className='col-xs-2'>
                  <a href={this.props.instagram} target="_blank" className='social-icons centered'>
                    <i className='fa fa-instagram'  />
                  </a>
                </div>
                <div className='col-xs-2'>
                  <a href={this.props.youtube} target="_blank" className='social-icons centered'>
                    <i className='fa fa-youtube'  />
                  </a>
                </div>
                <div className='col-xs-2' />
              </div>
              <div className='row'>
                <div className='col-xs-12 descriptive-text centered'>
                  <span className=''>Keep up-to-date with everything that happens in your world.</span>
                </div>
                <div className='col-xs-12'>
                  <div className='input-group'>
                    <input type='text' className='form-control' placeholder='Your Email Address' aria-label='Enter your email here to sign up for notifications' />
                    <span className='input-group-addon sign-up-button'>Sign-Up</span>
                  </div>
                </div>
                <div className='col-xs-12 centered'>
                  <span>
                    <span>We promise to never spam you. You can opt-out at any time. Please refer to our </span>
                    <a href={this.props.privacy}>Privacy Policy</a>
                    <span> for additional information. </span>
                  </span>
                </div>
              </div>
              <div className='row social-icon-row no-gutter'>
                <div className='col-xs-3 col-sm-6'>
                  <a href={this.props.products} className='primary-link centered'>Products</a>
                </div>
                <div className='col-xs-3 col-sm-6'>
                  <a href={this.props.about} className='primary-link centered '>Feedback</a>
                </div>
                <div className='col-xs-3 col-sm-6'>
                  <a href={this.props.careers} target="_blank" className='primary-link centered'>Careers</a>
                </div>
                <div className='col-xs-3 col-sm-6'>
                  <a href={this.props.tips} className='primary-link centered'>News Tips</a>
                </div>
              </div>
            </div>
            <div className='col-xs-6 col-sm-4 col-md-3 major-column '>
              <a className='map'
                style={{backgroundImage: `url(${this.state.mapUrl})`}}
                href={this.state.mapHref}></a>

            </div>
            <div className='col-xs-6 col-sm-4 col-md-3 major-column '>
              <div className='row text-center'>
                <div className='col-xs-12 col-sm-12  '>
                  <a href={this.props.about} className='primary-link '>{this.state.name}</a>
                  <div className='emphasis-text'>{this.state.address}</div>
                  <div className='emphasis-text'>{this.state.city}, {this.state.state} {this.state.zip}</div>
                  <div className='emphasis-text'>{this.state.phone}</div>
                  <br />
                </div>
                <div className='col-xs-12 col-sm-12'>
                  <div >Our Lobby Hours</div>
                  <div className='row small-emphasis-text '>
                    <div className='col-xs-6 hidden-xs'>Monday-Friday</div>
                    <div className='col-xs-6 visible-xs-block'>Mon-Fri</div>
                    <div className='col-xs-6'>8:30-5:30</div>
                  </div>
                  <div className='row small-emphasis-text '>
                    <div className='col-xs-6 hidden-xs'>Saturday-Sunday</div>
                    <div className='col-xs-6 visible-xs-block'>Sat-Sun</div>
                    <div className='col-xs-6 '>CLOSED</div>
                  </div>
                  <div className='row small-emphasis-text '>
                    <div className='col-xs-6'>Holidays</div>
                    <div className='col-xs-6'>Call First
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-12  col-md-3 major-column griffin-details '>
              <i className='fa fa-copyright' aria-hidden='true' />{(new Date()).getFullYear()}&nbsp;
              <a href='https://griffincommunications.net/'>Griffin Communications.</a>
              <span>{this.state.shortUrl} is proud to provide Oklahomans with timely and relevant news and information, sharing the stories, pictures and loves of Oklahomans across our great state. </span>
                <a href={this.props.privacy}>Privacy Policy</a>,&nbsp;
                <a href={this.props.terms}>Terms of Service</a>,&nbsp;
                <a href={this.props.legal}>Legal Notices</a>,&nbsp;
                <a href='https://optout.aboutads.info/#!/' target="_blank">Ad Choices</a>,&nbsp;
                <a href={this.props.inspection}>Public Inspection File Contact</a>,&nbsp;
                <a href={this.props.station} target='_blank'>Public Inspection File</a>,&nbsp;
                <a href={this.props.captioning}>Closed Captioning Assistance</a>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Footer/index.js